import request from '@/utils/request'

// 添加待办跳过记录
export function addTodoSkip(data) {
  return request({
    url: '/api/todo-skip/add',
    method: 'post',
    data
  })
}

// 获取待办跳过列表
export function getTodoSkipList(todoType) {
  return request({
    url: '/api/todo-skip/list',
    method: 'get',
    params: {
      todo_type: todoType
    }
  })
}

// 取消待办跳过（软删除）
export function removeTodoSkip(data) {
  return request({
    url: '/api/todo-skip/remove',
    method: 'delete',
    data
  })
}

